module.exports = __webpack_public_path__ + "img/Baidu.7352a0da.png";